import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import ConfettiBurst from './ConfettiBurst';

const { FiAward, FiCheck, FiX } = FiIcons;

function LessonBadgeModal({
  isOpen,
  lesson,
  onClose,
  onCompleteLesson
}) {
  const [isSaving, setIsSaving] = React.useState(false);

  if (!lesson) return null;

  const isCompleted = lesson.status === 'completed';

  const handleComplete = async () => {
    if (!isCompleted) {
      try {
        setIsSaving(true);
        await onCompleteLesson?.(lesson.id);
      } catch {
        return;
      } finally {
        setIsSaving(false);
      }
    }
    onClose();
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          animate={{ opacity: 1 }}
          aria-labelledby="lesson-badge-title"
          aria-modal="true"
          className="badge-modal-backdrop"
          initial={{ opacity: 0 }}
          role="dialog"
        >
          <ConfettiBurst />

          <motion.div
            animate={{ opacity: 1, scale: 1, y: 0 }}
            className="lesson-badge-card"
            initial={{ opacity: 0, scale: 0.94, y: 18 }}
            transition={{ duration: 0.3, ease: 'easeOut' }}
          >
            <button
              aria-label="Close lesson reward"
              className="badge-modal-close"
              onClick={onClose}
              type="button"
            >
              <SafeIcon icon={FiX} />
            </button>

            <div className="badge-emblem">
              <span className="badge-emblem-ring">
                <SafeIcon icon={FiAward} />
              </span>
              <span className="badge-emblem-leaf">🏅</span>
            </div>

            <span className="badge-kicker">Lesson badge earned</span>
            <h2 id="lesson-badge-title">Lesson Complete!</h2>
            <p>
              You stayed curious and worked through{' '}
              <strong>{lesson.title}</strong>.
            </p>

            <div className="badge-lesson-label">
              <SafeIcon icon={FiCheck} />
              {lesson.title}
            </div>

            <div className="badge-modal-actions">
              <button
                className="badge-secondary-action"
                disabled={isSaving}
                onClick={onClose}
                type="button"
              >
                Keep chatting
              </button>
              <button
                className="badge-primary-action"
                disabled={isSaving}
                onClick={handleComplete}
                type="button"
              >
                <SafeIcon icon={FiCheck} />
                {isSaving
                  ? 'Saving...'
                  : isCompleted
                    ? 'Close reward'
                    : 'Mark lesson complete'}
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default LessonBadgeModal;